(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name annualLeaveBidding.service:AnnualLeaveBiddingService
     *
     * @description
     *
     */
    angular
        .module('annualLeaveBidding')
        .service('AnnualLeaveBiddingService', AnnualLeaveBiddingService);

    function AnnualLeaveBiddingService(RemoteService) {

    	 var self = this;

         var model={
            rolesList:[]
        };

         var component = {categoryLabel:'childElements', uniqueField: 'valueFieldName'}


         self.getcomponent = function(){
        	 return component;
         };


      self.getAnnualLeaveBiddingResponse = function(data,successFn, errorFn){
        RemoteService.getAnnualLeaveBiddingResponse(data).then(
          function (response) {
            if(response.success){
              successFn(response);
            }
          },
          function (error) {
            errorFn(error.msg[0]);
          }
        );
      };



    }
})();
